import React, { memo } from 'react';
import { ButtonLinkWrapper, ReadMoreButton } from '@yme/molecules/buttons';
import { colorCoreBlack300 } from '@yme/tokens/colors';
import { FlexWrapper } from '@yme/tokens/flexTokens';
import { RegularTextLevel2 } from '@yme/tokens/typography';
import { isExternalLink, isPDFlink } from '@yme/utils/common';
import { AspectRatio, BLANK, SELF } from '@yme/utils/constants';
import { ContentStyled, ForOwnersWrapper, ImageWrapperStyled } from './styled';
const dataTestIdCard = 'card';
function ForOwnersCardComponent(props) {
    const { cardProps, isRightToLeft, marginBottom = 'auto' } = props;
    const { image, title, description, link, labelLink, countLineVisible = 3, isEllipsisEndingLine = true, aspectRatio = AspectRatio.RectangleLevel6, } = cardProps;
    const linkTarget = link && (isExternalLink(link) || isPDFlink(link) ? BLANK : SELF);
    const toRoute = link && isExternalLink(link)
        ? {
            pathname: link,
        }
        : link || '';
    return (React.createElement(ForOwnersWrapper, { marginBottom: marginBottom },
        React.createElement(FlexWrapper, { mb: "16px", mbTablet: "16px" },
            React.createElement(ButtonLinkWrapper, { isExternal: isPDFlink(link), buttonLink: link },
                React.createElement(ImageWrapperStyled, { ...image, alt: title, dataTestId: dataTestIdCard, aspectRatio: aspectRatio }))),
        React.createElement(FlexWrapper, { mb: "8px", mbTablet: "8px" },
            React.createElement(RegularTextLevel2, { weight: 500, title: title, isEllipsisEndingLine: isEllipsisEndingLine }, title)),
        React.createElement(FlexWrapper, { mb: "8px", mbTablet: "8px" },
            React.createElement(ContentStyled, { color: colorCoreBlack300, countLineVisible: countLineVisible }, description)),
        React.createElement(FlexWrapper, null,
            React.createElement(ReadMoreButton, { toRoute: toRoute, linkTarget: linkTarget, isRightToLeft: isRightToLeft, labelLink: labelLink }))));
}
export const ForOwnersCard = memo(ForOwnersCardComponent);
ForOwnersCard.displayName = 'ForOwnersCard_Molecule';
